exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-background thead{background-color:#a9e4ce;border:2px solid #d3d3d3;position:sticky;top:0;font-size:11px}.my-custom-scrollbar{height:550px;overflow:auto}.table-wrapper-scroll-y{display:block}.status-alerts{font-size:18px;flex-direction:column}.alert{padding:10px;margin-bottom:10px;border-radius:5px;color:#fff}.alert-danger-text{color:#d9534f}.alert-info-text{color:#2a6fde}@keyframes blink{0%,to{opacity:1}50%{opacity:0}}.blink{animation:blink 1s infinite;font-weight:800;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c647bfb0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/agentDash/agentCmsDash.vue
// module id = 1797
// module chunks = 0